const session = require('@flowio/session');

function localizeText() {
  const experience = session.getExperience();
  const priceElements = window && window.document && window.document.querySelectorAll('[flow-text]');

  if (!experience) {
    return;
  }

  for (let i = 0; i < priceElements.length; i += 1) {
    const elem = priceElements[i];
    const label = elem.getAttribute(`flow-text-${experience}`);
    if (label) {
      elem.innerHTML = label;
    }
  }
}

function localize() {
  localizeText();
}

module.exports = {
  localize,
  localizeText,
};



// WEBPACK FOOTER //
// ./static/js/v0/text.js